// extracted by mini-css-extract-plugin
export default {"page":"RX-z","cartModal":"SX-z","checkout":"TX-z","placeholder":"UX-z","account":"VX-z"};